import React, { useEffect } from 'react';
import { useState } from 'react';
import './index.scss';
import gtm from 'eco-design-reliance/gtm';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import TypeContent from '../TypeContent';

interface Props {
    prefixCls: string;
    item: any;
    title: string;
}

const CardTypeA: React.FC<Props> = ({ prefixCls, item, title }) => {
    const [activeIndex, setActiveIndex] = useState(-1);

    const lItems = item.subs || [];
    const activeItemB = lItems[activeIndex] || {};

    const [lineStyle, setLineStyle] = useState({
        width: 0,
        translateX: 0,
    });
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (isH5HandleClient()) return;
        const target = document.querySelector(`.${prefixCls}-card-type-a__tabs-item.active`) as HTMLDivElement;
        if (!target) return;
        setLineStyle({
            width: target.offsetWidth,
            translateX: target.offsetLeft,
        });
    }, [activeIndex, prefixCls]);
    useEffect(() => {
        if (isH5HandleClient()) return;
        setActiveIndex(0);
    }, []);
    const handleActive = (index: number, i: any, e: any) => {
        setActiveIndex(index);
        gtm.push({
            event: 'uaEvent',
            event_name: 'top_second_navigation',
            navigation_name: `${title}_${i.name}`,

            __btn_id1: `header-nvd-t2-i-${index}`,
            __btn_id2: `nvd-i-t2-${i.id}`,
            __btn_type: 'common',
        });
        if (isH5HandleClient() && index !== -1) {
            const target = e.currentTarget as HTMLDivElement;
            const content = document.querySelector('.ef-header-v2-nav-list__dropdown');
            if (!target || !content) return;
            const { offsetHeight } = target;
            content.scrollTo({
                top: offsetHeight * index,
                behavior: 'smooth',
            });
        }
    };
    if (lItems.length === 0) return <div className={`${prefixCls}-card-type-a`}></div>;
    return (
        <div className={`${prefixCls}-card-type-a`}>
            <div className={`${prefixCls}-card-type-a__tabs`}>
                {lItems.map((i: any, idx: number) => (
                    <div
                        className={`${prefixCls}-card-type-a__tabs-item-content ${
                            activeIndex === idx ? `${prefixCls}-card-type-a__tabs-item-content-active` : ''
                        }`}
                        key={idx}
                    >
                        <div
                            className={`${prefixCls}-card-type-a__tabs-item ${
                                activeIndex === idx ? 'active' : ''
                            } GtmModuleData-btn-common header-nvd-t2-i-${idx}`}
                            data-btn-id={`nvd-i-t2-${i.id}`}
                            onClick={(e) => (isH5HandleClient() ? handleActive(idx === activeIndex ? -1 : idx, i, e) : handleActive(idx, i, e))}
                        >
                            {i.name}
                        </div>
                        <TypeContent prefixCls={prefixCls} activeItemB={activeItemB} isH5 active={activeIndex === idx} title={title} />
                    </div>
                ))}

                {/* 选中线条 */}
                <div
                    className={`${prefixCls}-card-type-a__tabs-line`}
                    style={{
                        width: lineStyle.width,
                        transform: `translateX(${lineStyle.translateX}px)`,
                    }}
                ></div>
            </div>
            <TypeContent prefixCls={prefixCls} activeItemB={activeItemB} title={title} />
        </div>
    );
};
export default CardTypeA;
